/**
 * Admin domain model
 * Represents an administrator user in the system
 */
export interface Admin {
  readonly id: string;
  readonly name: string;
  readonly email: string;
  readonly language: string;
  readonly timezone: string;
  readonly createdAt: Date;
  readonly updatedAt: Date;
}

/**
 * Factory function to create an Admin instance
 */
export const createAdmin = (data: {
  id: string;
  name: string;
  email: string;
  language?: string;
  timezone?: string;
  createdAt?: Date;
  updatedAt?: Date;
}): Admin => {
  return {
    id: data.id,
    name: data.name,
    email: data.email,
    language: data.language ?? 'en-GB',
    timezone: data.timezone ?? 'UTC',
    createdAt: data.createdAt || new Date(),
    updatedAt: data.updatedAt || new Date(),
  };
};
